// extracted by mini-css-extract-plugin
export var title = "survey-question-view-module--title--h-NMw";